import {
  moduleName,
  actionTypes,
  mutationTypes
} from '@/store/modals'
import store from '@/store'
import ModalType from '@/utils/dictionaries/modalType'

const Modals = {
  install: (Vue) => {
    const open = (modalType, content) => {
      if (modalType === ModalType.ConfirmationModal) {
        store.commit(`${moduleName}/${mutationTypes.MUTATION_SET_CONFIRMATION_MODAL}`)
        store.commit(`${moduleName}/${mutationTypes.MUTATION_SET_CONFIRMATION_MODAL_CONTENT}`, content)
        return
      }

      if (typeof modalType === 'object') {
        store.dispatch(`${moduleName}/${actionTypes.ACTION_SET_MODAL_CONTENTS}`, modalType)
        modalType = 'DefaultModal'
      } else if (content) {
        store.dispatch(`${moduleName}/${actionTypes.ACTION_SET_MODAL_CONTENTS}`, content)
      }

      store.dispatch(`${moduleName}/${actionTypes.ACTION_OPEN_MODAL}`, modalType)
    }
    // Function to update modal content
    const update = (modalType,content) => {
      store.commit(`${moduleName}/${mutationTypes.MUTATION_SET_CONFIRMATION_MODAL_CONTENT}`, content);
    };
    const close = (modalType) => {
      if (modalType === ModalType.ConfirmationModal) {
        store.dispatch(`${moduleName}/${actionTypes.ACTION_CLOSE_CONFIRMATION_MODAL}`)
        return
      }

      store.dispatch(`${moduleName}/${actionTypes.ACTION_CLOSE_MODAL}`)
    }

    Vue.prototype.$modals = {
      open,
      close,
      update
    }
  }
}

export default Modals
